import { createContext } from "react";

const UserContext = createContext({ token: null, user: null });

export default UserContext;
